<template>
  <ejs-dialog v-if="hackReset" :ref='refName'
              :target='target'
              :isModal='isModal'
              :width='width'
              :height='height'
              :minHeight='height'
              :header='header'
              :buttons='buttonGroup'
              v-bind:visible='visible'
              :beforeClose = 'clear'
              :showCloseIcon='closeIcon'
              :closeOnEscape='false'
              :zIndex="zIndex">
    <slot name="dialog-content"></slot>
  </ejs-dialog>
</template>
<script>
const defaultWidth = '800px';
const defaultHeight = '600px';
const defaultHeader = 'Info';
const dafaultVisible = false;
const deaultModel = true;
const defaultClose = true;
const defaultZindex = '1000';

export default {
  name: 'CustomDialog',
  props: [
    'element',
    'styles'
  ],
  data() {
    return {
      hackReset: true,
      target: this.element.target,
      width: !this.styles.width ? defaultWidth : this.styles.width,
      height: !this.styles.height ? defaultHeight : this.styles.height,
      header: !this.element.title ? defaultHeader : this.element.title,
      visible: !this.styles.visible ? dafaultVisible : this.styles.visible,
      isModal: !this.styles.model ? deaultModel : this.styles.model,
      closeIcon: !!this.element.isClose,
      buttonGroup: this.element.buttonGroup,
      zIndex: !this.styles.zIndex ? defaultZindex : this.styles.zIndex,
      refName: this.element.refName,
    };
  },
  mounted() {
    this.$refs[`${this.refName}`];
  },
  methods: {
    show() {
      this.$refs[`${this.refName}`].show();
    },
    close() {
      //this.clear();
      this.$refs[`${this.refName}`].hide();
    },
    clear() {
      this.$emit("afterClose")
      this.hackReset = false;
      this.$nextTick(() => {
        this.hackReset = true;
      });
      //this.$emit('close');
    }
  },
  watch: {
    'element.title': function (val) {
      this.header = val;
    },
    'element.buttonGroup': function (val) {
      this.buttonGroup = val;
    }
  }
};
</script>
<style>
</style>
